import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { getLifebooksChild } from 'redux/selectors';
import { createExportRequest } from 'services';
import { useCreateDispatches } from 'helpers/hooks';

export default function useExportPdfCallbacks({ getState, setOpen }) {
	const child = useSelector(getLifebooksChild);

	const { childId } = useParams();
	const { setLoader, setSnackbar } = useCreateDispatches();
	const user = useSelector((state) => state.user.user);

	let childOrUserId;

	if (!childId) {
		childOrUserId = user.id;
	} else {
		childOrUserId = childId;
	}

	const handleValidate = () => {
		const { reason, receiverName, receiverRelation } = getState();

		let validationError = '';
		if (!reason || !receiverName || !receiverRelation) {
			validationError +=
				'Name, Relation and Reason fields are all required for exports';
		}
		if (!validationError) {
			return true;
		} else {
			setSnackbar({ variant: 'error', message: validationError });
		}
	};

	const onExportPdf = async (pass) => {
		setLoader(true);
		const state = getState();
		createExportRequest({ childId: childOrUserId, ...state, pass })
			.then(() => {
				setSnackbar({
					variant: 'success',
					message: child.privatizePosts
						? 'Request to export Lifebook has been sent'
						: 'Export successful. Please check your email.',
				});
				setOpen(false);
			})
			.catch((err) => {
				setSnackbar({
					variant: 'error',
					message:
						(err.response && err.response.data.message) ||
						'This request cannot be processed at this time.',
				});
			})
			.finally(() => {
				setLoader(false);
			});
	};

	return { onExportPdf, handleValidate };
}
